import {throttle} from "throttle-debounce";

/**
 * Sets up video playback for content and media blocks
 */

export namespace ContentAndMedia {
	let SetupContentAndMedia = () => {
		let videoContainers = document.querySelectorAll('.js-content-and-media-video');
		let videoViewerInstances = [];

		videoContainers.forEach((videoContainer) => {
			let asset = videoContainer.getAttribute('data-src');
			let poster = videoContainer.getAttribute('data-poster');

			//@ts-ignore
			let videoViewer = new s7viewers.VideoViewer({
				"containerId" : videoContainer.getAttribute('id'),
				"params" : {
					"asset" : `Baldwin/${asset}`,
					"serverurl" : "https://images.baldwinhardware.com/is/image/",
					"videoserverurl": "https://images.baldwinhardware.com/is/content/"
				}
			});

			if(poster) {
				videoViewer.params["posterimage"] = `Baldwin/${poster}`;
			}

			videoViewerInstances.push(videoViewer);
			videoViewer.init();
		});

		let isScrolledIntoView = (elem) => {
			let docViewTop = window.scrollY;
			let docViewBottom = docViewTop + window.innerHeight;

			let elemTop = elem.offsetTop;
			let elemBottom = elemTop + elem.offsetHeight;

			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}

		window.addEventListener("scroll", () => {
			videoContainers.forEach((vidContainer, index) => {
				if(isScrolledIntoView(vidContainer)){
					//console.log(videoContainers[index]);
				} else {
					//videoViewerInstances[index].pause();
				}
			});
		});
	}


	/**
	 * Initialize our Accordion Module
	 */
	export const init = () => {
		SetupContentAndMedia();
	}
}


/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', ContentAndMedia.init);
} else {  // `DOMContentLoaded` has already fired
	ContentAndMedia.init();
}
